export class ShapeColorModel {
  id;
  featureId;
  primary;
  primary_border;
  primary_hover;

  constructor(id, featureId, featureName, primary, primary_border, primary_hover) {
    this.id = id;
    this.featureId = featureId;
    this.featureName = featureName;
    this.primary = primary;
    this.primary_border = primary_border;
    this.primary_hover = primary_hover;
  }
}
